import type { Article } from '@/types'

import { compareJalali } from '@/lib/format'

export const ARTICLES: Article[] = [
    {
        slug: 'api-design-standard',
        title: 'راهنمای استاندارد طراحی API در سامانه‌های بانکی',
        category: 'technical',
        subcategory: 'software-architecture',
        type: 'guide',
        status: 'published',
        summary: 'اصول، قراردادها و الزامات امنیتی طراحی APIهای REST در سامانه‌های بانکی بهسازان ملت؛ از نام‌گذاری منابع و نسخه‌بندی تا مدیریت خطا، صفحه‌بندی و Idempotency در تراکنش‌های مالی.',
        author: 'mahsa-karimi',
        owner: 'mahsa-karimi',
        unit: 'architecture',
        publishedAt: '1405/06/20',
        updatedAt: '1405/08/12',
        readMinutes: 14,
        views: 1284,
        likes: 96,
        confidentiality: 'internal',
        labels: ['api', 'rest', 'architecture', 'security', 'standard'],
        featured: true
    },
    {
        slug: 'corporate-banking-lessons',
        title: 'درس‌آموخته‌های پروژه توسعه بانکداری شرکتی',
        category: 'project',
        subcategory: 'lessons-learned',
        type: 'lesson',
        status: 'published',
        summary: 'مرور تجربه‌های تیم در بازطراحی سامانه بانکداری شرکتی؛ از چالش یکپارچه‌سازی با هسته بانکی و مدیریت تغییر الزامات تا استقرار مرحله‌ای برای مشتریان حقوقی.',
        author: 'reza-ahmadi',
        owner: 'reza-ahmadi',
        unit: 'corporate-banking',
        publishedAt: '1405/08/10',
        updatedAt: '1405/08/10',
        readMinutes: 9,
        views: 642,
        likes: 58,
        confidentiality: 'internal',
        labels: ['corporate-banking', 'lessons', 'requirements', 'core-banking'],
        lesson: {
            project: 'سامانه بانکداری شرکتی، نسخه ۳',
            challenge: 'تغییرات مکرر الزامات مشتریان حقوقی در میانه توسعه، زمان‌بندی تحویل را دو بار به تعویق انداخت.',
            solution: 'تعریف نسخه حداقلی قابل استقرار با مشارکت واحد کسب‌وکار و جلسات بازبینی دوهفته‌ای با نماینده مشتریان کلیدی.',
            outcome: 'تحویل فاز نخست در موعد مقرر و کاهش ۴۰ درصدی درخواست‌های تغییر پس از استقرار.'
        }
    },
    {
        slug: 'payment-connectivity-errors',
        title: 'دستورالعمل بررسی خطاهای ارتباطی سرویس‌های پرداخت',
        category: 'technical',
        subcategory: 'infrastructure',
        type: 'instruction',
        status: 'published',
        summary: 'روال گام‌به‌گام شناسایی، دسته‌بندی و رفع خطاهای ارتباطی میان سرویس‌های پرداخت، سوئیچ و شبکه شاپرک؛ همراه با کدهای خطای رایج و مسیر تشدید به تیم‌های مسئول.',
        author: 'amir-taheri',
        owner: 'amir-taheri',
        unit: 'payments',
        publishedAt: '1405/05/18',
        updatedAt: '1405/08/07',
        readMinutes: 11,
        views: 2310,
        likes: 141,
        confidentiality: 'internal',
        labels: ['payment', 'shaparak', 'troubleshooting', 'network', 'incident'],
        featured: true
    },
    {
        slug: 'log-analysis-tools',
        title: 'راهنمای استفاده از ابزارهای تحلیل لاگ',
        category: 'learning',
        subcategory: 'tools-training',
        type: 'training',
        status: 'published',
        summary: 'آموزش کاربردی جست‌وجو، فیلتر و تحلیل لاگ سرویس‌ها در Kibana؛ از نوشتن کوئری‌های KQL تا ردیابی یک تراکنش با شناسه رهگیری در چند سرویس و ساخت داشبورد پایش.',
        author: 'hamid-norouzi',
        owner: 'hamid-norouzi',
        unit: 'infrastructure',
        publishedAt: '1405/08/05',
        updatedAt: '1405/08/05',
        readMinutes: 12,
        views: 1095,
        likes: 87,
        confidentiality: 'public',
        labels: ['logging', 'kibana', 'monitoring', 'training'],
        format: 'video',
        duration: '۳۵ دقیقه'
    },
    {
        slug: 'process-documentation-standard',
        title: 'استاندارد مستندسازی فرایندهای سازمانی',
        category: 'process',
        subcategory: 'guidelines',
        type: 'instruction',
        status: 'published',
        summary: 'چارچوب یکسان مستندسازی فرایندهای کاری در بهسازان ملت؛ شامل ساختار شناسنامه فرایند، نمادگذاری BPMN، تعیین مالک فرایند و چرخه بازبینی سالانه.',
        author: 'zahra-ghasemi',
        owner: 'zahra-ghasemi',
        unit: 'process-quality',
        publishedAt: '1405/08/01',
        updatedAt: '1405/08/01',
        readMinutes: 8,
        views: 534,
        likes: 39,
        confidentiality: 'public',
        labels: ['process', 'documentation', 'bpmn', 'standard']
    },
    {
        slug: 'security-predeploy-checklist',
        title: 'چک‌لیست امنیتی پیش از استقرار سرویس‌ها در محیط عملیاتی',
        category: 'technical',
        subcategory: 'information-security',
        type: 'instruction',
        status: 'published',
        summary: 'فهرست کنترل‌های امنیتی الزامی پیش از انتقال هر سرویس به محیط عملیاتی؛ از اسکن آسیب‌پذیری وابستگی‌ها و مدیریت اسرار تا پیکربندی TLS و ثبت رویدادهای امنیتی.',
        author: 'negar-salehi',
        owner: 'negar-salehi',
        unit: 'security',
        publishedAt: '1405/02/14',
        updatedAt: '1405/07/22',
        readMinutes: 7,
        views: 3120,
        likes: 204,
        confidentiality: 'internal',
        labels: ['security', 'deployment', 'checklist', 'devsecops'],
        featured: true
    },
    {
        slug: 'dev-environment-onboarding',
        title: 'راهنمای راه‌اندازی محیط توسعه برای همکاران جدید',
        category: 'learning',
        subcategory: 'practical-guides',
        type: 'training',
        status: 'published',
        summary: 'هر آنچه همکار تازه‌وارد تیم‌های توسعه برای آماده‌سازی محیط کار در هفته نخست نیاز دارد؛ از درخواست دسترسی‌ها و نصب ابزارها تا اجرای نخستین سرویس روی محیط آزمایشی.',
        author: 'mohammad-jafari',
        owner: 'mohammad-jafari',
        unit: 'learning',
        publishedAt: '1405/01/28',
        updatedAt: '1405/07/30',
        readMinutes: 15,
        views: 2780,
        likes: 176,
        confidentiality: 'public',
        labels: ['onboarding', 'dev-environment', 'training'],
        featured: true,
        format: 'guide',
        duration: '۲ ساعت'
    },
    {
        slug: 'access-request-process',
        title: 'چگونه دسترسی به سامانه‌های عملیاتی را درخواست کنیم؟',
        category: 'process',
        subcategory: 'workflows',
        type: 'qa',
        status: 'needs-update',
        summary: 'پاسخ به پرسش‌های پرتکرار درباره درخواست، تأیید و تمدید دسترسی به سامانه‌های عملیاتی؛ شامل سطوح دسترسی، مراجع تأیید و زمان معمول رسیدگی.',
        author: 'zahra-ghasemi',
        owner: 'negar-salehi',
        unit: 'process-quality',
        publishedAt: '1404/11/20',
        updatedAt: '1404/11/20',
        readMinutes: 5,
        views: 2045,
        likes: 98,
        confidentiality: 'public',
        labels: ['access-management', 'process', 'security']
    },
    {
        slug: 'microservices-reference-architecture',
        title: 'معماری مرجع میکروسرویس‌ها در سامانه‌های پرداخت',
        category: 'technical',
        subcategory: 'software-architecture',
        type: 'guide',
        status: 'published',
        summary: 'الگوی مرجع تفکیک سرویس‌ها، ارتباط رویدادمحور، مدیریت تراکنش‌های توزیع‌شده با الگوی Saga و الزامات مشاهده‌پذیری برای سامانه‌های پرداخت پرتراکنش.',
        author: 'mahsa-karimi',
        owner: 'mahsa-karimi',
        unit: 'architecture',
        publishedAt: '1404/12/10',
        updatedAt: '1405/07/15',
        readMinutes: 18,
        views: 1960,
        likes: 133,
        confidentiality: 'internal',
        labels: ['microservices', 'architecture', 'payment', 'kafka', 'saga'],
        featured: true
    },
    {
        slug: 'infrastructure-monitoring-patterns',
        title: 'الگوهای پایش و هشداردهی زیرساخت',
        category: 'technical',
        subcategory: 'infrastructure',
        type: 'guide',
        status: 'published',
        summary: 'استاندارد تعریف شاخص‌ها، آستانه‌های هشدار و داشبوردهای پایش برای سرورها، پایگاه‌های داده و سرویس‌های حیاتی؛ با هدف کاهش هشدارهای کاذب و تشخیص زودهنگام اختلال.',
        author: 'hamid-norouzi',
        owner: 'hamid-norouzi',
        unit: 'infrastructure',
        publishedAt: '1405/03/05',
        updatedAt: '1405/06/28',
        readMinutes: 10,
        views: 1415,
        likes: 92,
        confidentiality: 'internal',
        labels: ['monitoring', 'alerting', 'infrastructure', 'grafana']
    },
    {
        slug: 'card-db-migration-lessons',
        title: 'درس‌آموخته‌های مهاجرت پایگاه داده سامانه کارت',
        category: 'project',
        subcategory: 'lessons-learned',
        type: 'lesson',
        status: 'published',
        summary: 'تجربه انتقال پایگاه داده سامانه صدور و مدیریت کارت به زیرساخت جدید بدون توقف سرویس؛ از چالش همگام‌سازی داده در زمان مهاجرت تا طراحی سناریوی بازگشت امن.',
        author: 'pouya-hosseini',
        owner: 'pouya-hosseini',
        unit: 'card-systems',
        publishedAt: '1405/07/26',
        updatedAt: '1405/07/26',
        readMinutes: 10,
        views: 876,
        likes: 74,
        confidentiality: 'internal',
        labels: ['database', 'migration', 'card', 'lessons'],
        lesson: {
            project: 'نوسازی زیرساخت سامانه کارت',
            challenge: 'انتقال بیش از ۸ ترابایت داده تراکنشی بدون توقف سرویس‌دهی به شبکه شتاب.',
            solution: 'مهاجرت مرحله‌ای با همگام‌سازی دوطرفه، سه اجرای آزمایشی در محیط شبیه‌سازی و طراحی سناریوی بازگشت در کمتر از ۱۵ دقیقه.',
            outcome: 'انتقال کامل در دو پنجره زمانی شبانه، بدون حتی یک دقیقه توقف در خدمات کارت.'
        }
    },
    {
        slug: 'loan-system-architecture-docs',
        title: 'مستندات معماری سامانه یکپارچه تسهیلات',
        category: 'project',
        subcategory: 'project-docs',
        type: 'project-doc',
        status: 'published',
        summary: 'مستند مرجع معماری سامانه یکپارچه تسهیلات؛ شامل نمای کلی اجزا، جریان داده میان سامانه اعتبارسنجی و هسته بانکی، تصمیمات معماری و وابستگی‌های بیرونی.',
        author: 'samira-nazari',
        owner: 'samira-nazari',
        unit: 'lending',
        publishedAt: '1405/04/18',
        updatedAt: '1405/07/08',
        readMinutes: 16,
        views: 728,
        likes: 41,
        confidentiality: 'internal',
        labels: ['architecture', 'lending', 'project-docs', 'core-banking']
    },
    {
        slug: 'mobile-canary-release-lessons',
        title: 'تجربه استقرار تدریجی نسخه جدید همراه‌بانک',
        category: 'project',
        subcategory: 'project-experiences',
        type: 'lesson',
        status: 'published',
        summary: 'روایت انتشار تدریجی نسخه جدید اپلیکیشن همراه‌بانک برای ۵ درصد کاربران، پایش شاخص‌های خطا و تصمیم‌گیری داده‌محور برای گسترش انتشار.',
        author: 'ali-sharifi',
        owner: 'ali-sharifi',
        unit: 'digital-banking',
        publishedAt: '1405/06/12',
        updatedAt: '1405/06/30',
        readMinutes: 8,
        views: 1188,
        likes: 102,
        confidentiality: 'internal',
        labels: ['mobile-banking', 'release', 'feature-flag', 'lessons'],
        lesson: {
            project: 'همراه‌بانک، نسخه ۸',
            challenge: 'انتشار یک‌باره نسخه‌های پیشین، در دو مورد به افزایش ناگهانی خطای ورود و تماس‌های پشتیبانی منجر شده بود.',
            solution: 'انتشار مرحله‌ای ۵، ۲۵ و ۱۰۰ درصدی با کلید ویژگی و معیارهای توقف خودکار مبتنی بر نرخ خطا.',
            outcome: 'شناسایی یک خطای حیاتی در مرحله ۵ درصد و رفع آن پیش از رسیدن نسخه به عموم کاربران.'
        }
    },
    {
        slug: 'account-inquiry-latency-improvement',
        title: 'کاهش زمان پاسخ‌گویی سرویس استعلام حساب',
        category: 'innovation',
        subcategory: 'improvement-solutions',
        type: 'lesson',
        status: 'published',
        summary: 'راهکاری که زمان پاسخ سرویس استعلام حساب را در ساعات اوج از ۱٫۲ ثانیه به ۲۸۰ میلی‌ثانیه رساند؛ با بازطراحی لایه کش، تجمیع فراخوانی‌های تکراری و بهینه‌سازی کوئری‌ها.',
        author: 'amir-taheri',
        owner: 'amir-taheri',
        unit: 'payments',
        publishedAt: '1405/05/02',
        updatedAt: '1405/05/20',
        readMinutes: 7,
        views: 1342,
        likes: 118,
        confidentiality: 'internal',
        labels: ['performance', 'cache', 'database', 'lessons'],
        lesson: {
            project: 'سرویس‌های پایه حساب',
            challenge: 'افزایش زمان پاسخ سرویس استعلام حساب در ساعات اوج و اثر زنجیره‌ای آن بر سرویس‌های انتقال وجه.',
            solution: 'پیاده‌سازی کش توزیع‌شده با زمان انقضای کوتاه، تجمیع فراخوانی‌های تکراری و افزودن ایندکس‌های ترکیبی.',
            outcome: 'کاهش میانگین زمان پاسخ به ۲۸۰ میلی‌ثانیه و کاهش ۳۵ درصدی بار پایگاه داده.'
        }
    },
    {
        slug: 'failed-transactions-analysis-1405',
        title: 'تحلیل روند تراکنش‌های ناموفق درگاه‌های پرداخت در نیمه نخست ۱۴۰۵',
        category: 'analytics',
        subcategory: 'analytical-reports',
        type: 'research',
        status: 'published',
        summary: 'بررسی علل اصلی ناموفق‌بودن تراکنش‌های درگاه پرداخت اینترنتی در شش ماه نخست سال، سهم هر علت و پیشنهادهای اولویت‌دار برای کاهش نرخ خطا.',
        author: 'fatemeh-mousavi',
        owner: 'fatemeh-mousavi',
        unit: 'data-analytics',
        publishedAt: '1405/07/18',
        updatedAt: '1405/07/18',
        readMinutes: 13,
        views: 812,
        likes: 63,
        confidentiality: 'confidential',
        labels: ['payment', 'analytics', 'report', 'ipg']
    },
    {
        slug: 'open-banking-comparative-study',
        title: 'مطالعه تطبیقی بانکداری باز و الزامات پیاده‌سازی آن',
        category: 'analytics',
        subcategory: 'specialized-studies',
        type: 'research',
        status: 'published',
        summary: 'مرور تجربه کشورهای پیشرو در بانکداری باز، مدل‌های حاکمیت API، الزامات امنیتی و حقوقی و ارزیابی آمادگی زیرساخت‌های فعلی برای ارائه خدمت به شرکت‌های فناوری مالی.',
        author: 'mahsa-karimi',
        owner: 'mahsa-karimi',
        unit: 'architecture',
        publishedAt: '1405/03/22',
        updatedAt: '1405/04/10',
        readMinutes: 20,
        views: 954,
        likes: 77,
        confidentiality: 'internal',
        labels: ['open-banking', 'api', 'fintech', 'research', 'strategy']
    },
    {
        slug: 'change-management-procedure',
        title: 'رویه اجرایی مدیریت تغییرات در محیط عملیاتی',
        category: 'process',
        subcategory: 'procedures',
        type: 'instruction',
        status: 'published',
        summary: 'رویه ثبت، ارزیابی ریسک، تأیید و اجرای تغییرات در سامانه‌های عملیاتی مطابق چارچوب ITIL؛ شامل انواع تغییر، ترکیب کمیته تغییرات و پنجره‌های زمانی مجاز.',
        author: 'zahra-ghasemi',
        owner: 'zahra-ghasemi',
        unit: 'process-quality',
        publishedAt: '1404/09/14',
        updatedAt: '1405/04/25',
        readMinutes: 9,
        views: 1675,
        likes: 88,
        confidentiality: 'public',
        labels: ['change-management', 'itil', 'process', 'deployment']
    },
    {
        slug: 'confluence-knowledge-training',
        title: 'آموزش ثبت و سازمان‌دهی دانش در Confluence',
        category: 'learning',
        subcategory: 'training-content',
        type: 'training',
        status: 'published',
        summary: 'دوره کوتاه ویدئویی برای آشنایی همکاران با ایجاد صفحه از قالب، افزودن برچسب و ویژگی‌های صفحه، پیوست فایل و استفاده از ماکروهای پرکاربرد در ثبت دانش.',
        author: 'mohammad-jafari',
        owner: 'mohammad-jafari',
        unit: 'learning',
        publishedAt: '1405/07/05',
        updatedAt: '1405/07/05',
        readMinutes: 6,
        views: 1530,
        likes: 121,
        confidentiality: 'public',
        labels: ['confluence', 'training', 'knowledge-management'],
        format: 'video',
        duration: '۴۰ دقیقه'
    },
    {
        slug: 'code-review-guide',
        title: 'راهنمای بازبینی کد در تیم‌های توسعه',
        category: 'learning',
        subcategory: 'practical-guides',
        type: 'training',
        status: 'published',
        summary: 'معیارهای مشترک بازبینی کد، چک‌لیست بازبین، شیوه ارائه بازخورد سازنده و نکات امنیتی که در بازبینی کد سامانه‌های مالی نباید از نظر دور بماند.',
        author: 'saeed-rostami',
        owner: 'saeed-rostami',
        unit: 'qa',
        publishedAt: '1405/04/02',
        updatedAt: '1405/06/15',
        readMinutes: 9,
        views: 1210,
        likes: 95,
        confidentiality: 'public',
        labels: ['code-review', 'quality', 'training', 'security'],
        format: 'guide',
        duration: '۲۵ دقیقه'
    },
    {
        slug: 'regression-test-automation',
        title: 'راهکار خودکارسازی آزمون‌های رگرسیون سرویس‌های کارت',
        category: 'innovation',
        subcategory: 'improvement-solutions',
        type: 'lesson',
        status: 'published',
        summary: 'تجربه تیم تضمین کیفیت در خودکارسازی ۱۲۰۰ سناریوی آزمون رگرسیون سامانه کارت که چرخه آزمون پیش از انتشار را از پنج روز به یک روز کاری کاهش داد.',
        author: 'saeed-rostami',
        owner: 'saeed-rostami',
        unit: 'qa',
        publishedAt: '1405/02/20',
        updatedAt: '1405/03/10',
        readMinutes: 8,
        views: 990,
        likes: 84,
        confidentiality: 'internal',
        labels: ['test-automation', 'quality', 'card', 'lessons'],
        lesson: {
            project: 'سامانه صدور و مدیریت کارت',
            challenge: 'آزمون دستی رگرسیون پیش از هر انتشار پنج روز کاری زمان می‌برد و گلوگاه اصلی چرخه انتشار بود.',
            solution: 'اولویت‌بندی سناریوها بر اساس ریسک، خودکارسازی تدریجی با چارچوب آزمون API و اجرای شبانه در خط استقرار.',
            outcome: 'کاهش زمان آزمون رگرسیون به یک روز کاری و شناسایی زودهنگام ۳۷ خطا در سه ماه نخست.'
        }
    },
    {
        slug: 'ai-support-assistant-idea',
        title: 'ایده: دستیار هوشمند پاسخ‌گویی به پرسش‌های پرتکرار پشتیبانی',
        category: 'innovation',
        subcategory: 'ideas',
        type: 'research',
        status: 'published',
        summary: 'پیشنهاد استفاده از پایگاه دانش موجود برای پاسخ‌گویی خودکار به پرسش‌های پرتکرار مرکز تماس، همراه با برآورد اولیه اثر بر زمان پاسخ‌گویی و ملاحظات امنیت داده.',
        author: 'ali-sharifi',
        owner: 'ali-sharifi',
        unit: 'digital-banking',
        publishedAt: '1405/06/25',
        updatedAt: '1405/06/25',
        readMinutes: 6,
        views: 705,
        likes: 69,
        confidentiality: 'public',
        labels: ['innovation', 'ai', 'support', 'idea']
    },
    {
        slug: 'shaparak-timeout-troubleshooting',
        title: 'چگونه خطای Timeout در فراخوانی سرویس‌های شاپرک را عیب‌یابی کنیم؟',
        category: 'technical',
        subcategory: 'software-development',
        type: 'qa',
        status: 'published',
        summary: 'پاسخ تیم پرداخت به یکی از پرتکرارترین پرسش‌های توسعه‌دهندگان: تفکیک Timeout شبکه از تأخیر پردازش، تنظیم درست زمان‌های انتظار و رفتار صحیح در برابر پاسخ‌های نامشخص.',
        author: 'amir-taheri',
        owner: 'amir-taheri',
        unit: 'payments',
        publishedAt: '1405/04/12',
        updatedAt: '1405/05/30',
        readMinutes: 6,
        views: 1720,
        likes: 110,
        confidentiality: 'internal',
        labels: ['shaparak', 'payment', 'troubleshooting', 'timeout']
    },
    {
        slug: 'idempotency-payment-services',
        title: 'راهنمای پیاده‌سازی Idempotency در سرویس‌های پرداخت',
        category: 'technical',
        subcategory: 'software-architecture',
        type: 'guide',
        status: 'in-review',
        summary: 'الگوی پیاده‌سازی کلید یکتایی درخواست در سرویس‌های پرداخت برای جلوگیری از ثبت دوباره تراکنش هنگام تلاش مجدد کلاینت یا قطع ارتباط شبکه.',
        author: 'mahsa-karimi',
        owner: 'mahsa-karimi',
        unit: 'architecture',
        publishedAt: '1405/08/09',
        updatedAt: '1405/08/09',
        readMinutes: 10,
        views: 0,
        likes: 0,
        confidentiality: 'internal',
        labels: ['idempotency', 'payment', 'api', 'architecture']
    },
    {
        slug: 'kafka-event-naming',
        title: 'استاندارد نام‌گذاری رویدادها در Kafka',
        category: 'technical',
        subcategory: 'software-development',
        type: 'instruction',
        status: 'returned',
        summary: 'قرارداد یکسان نام‌گذاری موضوع‌ها و رویدادهای Kafka در سرویس‌های رویدادمحور، شامل ساختار نام، نسخه‌بندی و مالکیت هر موضوع.',
        author: 'mahsa-karimi',
        owner: 'mahsa-karimi',
        unit: 'architecture',
        publishedAt: '1405/08/03',
        updatedAt: '1405/08/06',
        readMinutes: 6,
        views: 0,
        likes: 0,
        confidentiality: 'internal',
        labels: ['kafka', 'events', 'standard', 'microservices'],
        reviewNote: {
            reviewer: 'amir-taheri',
            date: '1405/08/06',
            text: 'ساختار کلی مناسب است. لطفاً نمونه نام‌گذاری رویدادهای خطا و جبرانی را اضافه کنید و سیاست نسخه‌بندی شِمای رویدادها را مشخص کنید تا تیم‌ها بدون ابهام از آن استفاده کنند.'
        }
    }
]

export const ARTICLE_BY_SLUG = Object.fromEntries(ARTICLES.map(article => [article.slug, article])) as Record<string, Article>

/** Visible to every colleague: published pages, including ones flagged for an update. */
export const isListed = (article: Article): boolean => article.status === 'published' || article.status === 'needs-update'

export const LISTED_ARTICLES = ARTICLES.filter(isListed)

export const byNewest = (a: Article, b: Article): number => compareJalali(b.updatedAt, a.updatedAt) || b.views - a.views

export const byViews = (a: Article, b: Article): number => b.views - a.views

export const byLikes = (a: Article, b: Article): number => b.likes - a.likes

export const articlesInCategory = (slug: string): Article[] => LISTED_ARTICLES.filter(article => article.category === slug)

export const articlesBy = (personSlug: string): Article[] => ARTICLES.filter(article => article.author === personSlug)

export const LESSONS = LISTED_ARTICLES.filter(article => article.type === 'lesson' && article.lesson)
